import React from 'react';
import {useTranslation} from 'react-i18next';

import styled from 'styled-components';

import {formField, newFormField} from '../FormField';
import NumberInput from '../NumberInput';
import {TValue} from '../TextInput';
import * as S from './style';
import {DEFAULT_WIDTH, OPTION_HEIGHT, TTimePickerProps, times} from './types';

export const TimePicker = React.memo<TTimePickerProps>(({options = times, innerRef, ...props}) => {
  const {t} = useTranslation();
  const selectedIndex = options.findIndex((option) => option === props.value);
  const scrollTo = selectedIndex === -1 ? 0 : OPTION_HEIGHT * (selectedIndex - 3);

  return (
    <S.TimePicker
      options={options}
      scrollTo={scrollTo}
      renderHead={(inputProps) => (
        <NumberInput
          innerRef={innerRef}
          autoComplete="off"
          placeholder={t('EdnaTimePicker:timePlaceholder')}
          leftChildren={<S.ClockIcon disabled={!!inputProps.disabled} />}
          numberFormat="##:##"
          mask="_"
          {...inputProps}
        />
      )}
      {...props}
    />
  );
});

const FullWidthTimePicker = styled(TimePicker)`
  width: 100%;
`;

export const TimePickerField = formField<TTimePickerProps, TValue>(FullWidthTimePicker, {
  width: DEFAULT_WIDTH,
});

export const NewTimePickerField = newFormField<TTimePickerProps>(FullWidthTimePicker, {
  width: DEFAULT_WIDTH,
});
